import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { dateFormat } from "../utils/functions";

export default function Timer({ selectedDrawParam = null }) {
  const selectedDraw = useSelector((state) => state.totoPlaceBet.selectedDraw);
  const Toto1Draw = useSelector((state) => state.drawSet.Toto1Draw);
  var [d, setDate] = useState(new Date());
  const cutOff = process.env.REACT_APP_CUT_OFF;

  useEffect(() => {
    var timer = null;
    timer = setInterval(() => setDate(new Date()), 1000);
    return function cleanup() {
      clearInterval(timer);
    };
  });

  const Toto1DrawComputed = () => {
    let Toto1Draw2 = Toto1Draw !== undefined ? [...Toto1Draw] : [];
    if (
      dateFormat("Y-m-d", d) === Toto1Draw2[0]?.date &&
      dateFormat("Hi", d) >= cutOff
    ) {
      Toto1Draw2.splice(0, 1);
    }
    return Toto1Draw2;
  };

  const print = () => {
    let selectedDrawParam2 = selectedDraw;

    if (selectedDrawParam !== null) selectedDrawParam2 = selectedDrawParam;

    let Toto1Draw2 = Toto1DrawComputed();
    let selectedDraw2 = [];
    if (selectedDrawParam2 === "Current") {
      if (Toto1Draw2[0] !== undefined) selectedDraw2.push(Toto1Draw2[0].no);
    }
    if (selectedDrawParam2 === "2 Draws") {
      if (Toto1Draw2[0] !== undefined) selectedDraw2.push(Toto1Draw2[0].no);
      if (Toto1Draw2[1] !== undefined) selectedDraw2.push(Toto1Draw2[1].no);
    }
    if (selectedDrawParam2 === "4 Draws") {
      if (Toto1Draw2[0] !== undefined) selectedDraw2.push(Toto1Draw2[0].no);
      if (Toto1Draw2[1] !== undefined) selectedDraw2.push(Toto1Draw2[1].no);
      if (Toto1Draw2[2] !== undefined) selectedDraw2.push(Toto1Draw2[2].no);
      if (Toto1Draw2[3] !== undefined) selectedDraw2.push(Toto1Draw2[3].no);
    }
    return selectedDraw2;
  };

  return (
    <div style={{ marginBottom: 20 }}>
      {/* {dateFormat("Y-m-d H:i:s", d)}
      <br />
      Hi: {dateFormat("Hi", d)}
      <br />
      cutOff: {cutOff}
      <br />
      <pre>{JSON.stringify(DrawToto, null, 2)}</pre>
      <br />
      DrawTotoComputed: <pre>{JSON.stringify(DrawTotoComputed(), null, 2)}</pre>
      <br />
      {selectedDraw}
      <br /> */}

      {print().map((a, aI) => (
        <div key={aI}>{a}</div>
      ))}
    </div>
  );
}
